/**
 * What a quotation line's stored `pricingSource` reads as on a screen.
 *
 * Two private copies of this map existed — the quotation page's and the Add
 * Item modal's — and they had already drifted: only the page had learned
 * 'master_catalogue' (QUO-00017), so the modal printed the raw key. The Master
 * Catalogue screen needs the same words for a quotation line's options banner,
 * which would have made three.
 */
const LABELS: Readonly<Record<string, string>> = Object.freeze({
  historical_quotation: 'Historical Quotation',
  yelo_api: 'Yelo API',
  price_list: 'Price List',
  vendor_invoice: 'Vendor Invoice',
  client_provided: 'Client Provided',
  not_found: 'Not Found',
  // A row somebody typed into the Master Catalogue. Used to read "Price List",
  // which it never was (QUO-00017).
  master_catalogue: 'Master Catalogue',
  // A price typed straight onto the line while its catalogue-addition
  // submission waits for review (2026-09-23) — see the line's own marker
  // (`useCatalogueSubmissionMarkers`) for whether that review is still
  // pending or was refused.
  manual_entry: 'Manual Entry',
});

/** The label for a stored `pricingSource`. An unknown value is shown as stored; a missing one is ''. */
export function formatPricingSource(source?: string | null): string {
  if (!source) return '';
  return LABELS[source] || source;
}
